module.exports = __webpack_public_path__ + "static/media/personal_calendar.8a97cb98.svg";